//Menu burger
let $burgers = document.querySelectorAll('.header__menu-burger'); // 2 div for the desktop and mobile menu

let $menu = document.querySelector('.menu-mobile');
let $overlay = document.querySelector('.menu-mobile-overlay');
let $closeMenu = document.querySelectorAll('.close-icon');
let $linksWithSubmenu = document.querySelectorAll('.menu-mobile__link-list-item.has-submenu');
let $submenuWithSubmenu = document.querySelectorAll('.menu-mobile__link-list-subitem.has-submenu');
let $subMenus = document.querySelectorAll('.menu-mobile__link-list-container-subitems');
let $backSubMenus = document.querySelectorAll('.menu-mobile__subitems-return');
let $body = document.querySelector('body'); //Click on burger icon to open menu
let $lastOpenend = []

$burgers.forEach(burger => {
  burger.addEventListener('click', function (e) {
    e.preventDefault();
    $menu.classList.add('active');
    $body.classList.add('noscroll');
    $overlay.classList.add('active');
  });
}); //Click on close icon to close all menus

$closeMenu.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    $menu.classList.remove('active');
    $subMenus.forEach(subMenu => {
      subMenu.classList.remove('active');
    });
    $body.classList.remove('noscroll');
    $overlay.classList.remove('active');
  });
}); //Click on the overlay to close all menus

$overlay.addEventListener('click', () => {
  $menu.classList.remove('active');
  $subMenus.forEach(subMenu => {
    subMenu.classList.remove('active');
  });
  $body.classList.remove('noscroll');
  $overlay.classList.remove('active');
}); //Click on the link to open the corresponding submenu if there is one

$linksWithSubmenu.forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();
    let target = link.getAttribute('data-target'); //Get the data-target from the link

    let $subMenu = document.querySelector('#' + target); //Get the submenu with the id corresponding to the data-target
    $lastOpenend.push($subMenu)
    $subMenu.classList.add('active'); //Display submenu
  });
}); //Click on the back button to return to the main menu

$submenuWithSubmenu.forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();
    let target = link.getAttribute('data-target'); //Get the data-target from the link
    
    let $subMenu = document.querySelector('#' + target); //Get the submenu with the id corresponding to the data-target
    $lastOpenend.push($subMenu)
    $subMenu.classList.add('active'); //Display submenu
  });
}); //Click on the back button to return to the main menu

$backSubMenus.forEach(backSubMenu => {
  backSubMenu.addEventListener('click', function (e) {
    e.preventDefault();
    console.log("test");
    if($lastOpenend != null){
      const toReturn = $lastOpenend[$lastOpenend.length - 1]
      toReturn.classList.remove('active')
      $lastOpenend.pop()
    }
  });
});